import {
  resetFlightsForm,
  resetFlightsResults,
} from "../../../searchFlightsSlice";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons/faEdit";
import { ConfigSliceState, selectConfig } from "../../../../config/ConfigSlice";
import BookingButton from "../../../BookingButton";
import { useTranslation } from "react-i18next";
import RoundTripInput from "../../RoundTripInput";
import useFormInitialization from "../../../useFormInitialization";
import ResetFiltersIcon from "../../../../../images/custom/SFO/reset-filters.svg";
import ShowReturnInputSFO from "./ShowReturnInputSFO";
import ExcludeCodeShareInputSFO from "./ExcludeCodeShareInputSFO";
import FlightTypeInputSFO from "./FlightTypeInputSFO";
import TimeInputSFO from "./TimeInputSFO";
import AirportInputSFO from "./AirportInputSFO";
import DateInputSFO from "./DateInputSFO";
import SearchFlightsButtonSFO from "./SearchFlightsButtonSFO";
import FromToRadioSFO from "./FromToRadioSFO";

function SearchFlightsFormSFO() {
  const { t } = useTranslation();

  const loading = useFormInitialization();

  const { components }: ConfigSliceState = useAppSelector(selectConfig);

  if (loading) {
    return null;
  }

  return (
    <>
      <>
        {components.SearchPanel.HeaderStrap.display && (
          <div className="form-header">
            {t(components.SearchPanel.HeaderStrap.translation)}
          </div>
        )}
        <div className="block search-container">
          {components.Inputs.RoundTrip.display && <RoundTripInput />}
          <div className="columns is-mobile is-vcentered is-justify-content-space-between search-bar">
            <div className="column pl-0 is-one-fifth">
              <FromToRadioSFO />
            </div>
            <AirportInputSFO />
            <DateInputSFO />
            <div className="column pl-0 is-show is-one-quarter">
              <SearchButtonGroup />
            </div>
          </div>
          <div className="columns is-mobile is-vcentered is-justify-content-space-between search-bar">
            <div className="column is-hidden-div pb-0 pl-0 is-one-quarter">
              <p>Additional Options</p>
            </div>
            <div className="column pl-0 is-one-quarter">
              <div className="is-one-quarter checkbox-group">
                <ShowReturnInputSFO />
                <ExcludeCodeShareInputSFO />
              </div>
            </div>
            <FlightTypeInputSFO />
            <TimeInputSFO />
            <div className="column is-one-quarter pl-0" />
            <div className="column pl-0 is-hidden-div mt-5 is-one-quarter">
              <SearchButtonGroup />
            </div>
          </div>
        </div>
      </>
    </>
  );
}

function SearchButtonGroup() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const loading = useFormInitialization();

  const { mapper }: ConfigSliceState = useAppSelector(selectConfig);

  const formDisabled = useAppSelector(
    (state) => state.searchFlights.form.disabled
  );
  const resultsLoading = useAppSelector(
    (state) => state.searchFlights.results.loading
  );

  if (loading) {
    return null;
  }
  return (
    <div className="columns is-mobile btn-group">
      {(!formDisabled || resultsLoading) && (
        <div className="control">
          <button
            id="clear-form-button"
            disabled={resultsLoading}
            className="button is-light is-small is-align-self-flex-end"
            onClick={() => {
              if (!resultsLoading) {
                dispatch(resetFlightsForm());
              }
            }}
          >
            <span className="icon">
              <img src={ResetFiltersIcon} alt="reset"></img>
            </span>
            <span>{t("CLEAR_FORM")}</span>
          </button>
        </div>
      )}
      {(!formDisabled || resultsLoading) && (
        <div className="control">
          <SearchFlightsButtonSFO />
        </div>
      )}
      {formDisabled && !resultsLoading && (
        <>
          <div className="control">
            <button
              id="modify-search-button"
              className="button"
              onClick={() => {
                dispatch(resetFlightsResults("flights"));
              }}
            >
              <span className="icon">
                <FontAwesomeIcon icon={faEdit} />
              </span>
              <span>{t("MODIFY_SEARCH")}</span>
            </button>
          </div>
          {mapper.bookingLink.url && (
            <div className="control">
              <BookingButton />
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default SearchFlightsFormSFO;
